import Image from 'next/image';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import './style.sass';

const UniqueMarker = () => {
    return (
        <div className="aimed-unique-marker">
            <FullWrapper isMargin={false}>
                <div className="aimed-unique-markerWrapper">
                    <div className="aimed-unique-markerBlock">
                        <div className="aimed-unique-markerItem">
                            <Image
                                src="/images/pic/aimed/f4.png"
                                alt="cloud system"
                                width={1200}
                                height={767}
                                className="aimed-unique-markerImg"
                            />
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default UniqueMarker;
